import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Admin() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/admin-api/check', {
      credentials: 'include', // wichtig!
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        if (!data.authenticated) throw new Error();
        setLoading(false);
      })
      .catch(() => navigate('/login'));
  }, [navigate]);

  if (loading) return <p>Lade Adminbereich...</p>;

  return <h2>Willkommen im Adminbereich!</h2>;
}
